import React from "react";

import { setLocalStorageCountry, setLocalStorageZipCode, useTranslation, useUserContext } from "utils";

import { Breadcrumbs, Crumb, Flex, MainPage } from "components";

import { CropExplorationContextProvider } from "pages/app/crop-explorer/CropExplorationContext";
import { CropExplorationSidebar } from "pages/app/crop-explorer/components/CropExplorationSidebar";
import { CropExplorerTabs } from "pages/app/crop-explorer/components/CropExplorerTabs";

const Header = ({ crumbs, title, dataTestId, className }: { crumbs: Crumb[]; title: string; dataTestId: string; className?: string }) => (
  <div className={className} data-testid={dataTestId}>
    <Breadcrumbs items={crumbs} />
    <h1>{title}</h1>
  </div>
);

export const CropExplorerPage = () => {
  const { t } = useTranslation(["cropExplorer", "modules"]);
  const { user } = useUserContext();
  if (user?.farm?.country) setLocalStorageCountry(user.farm.country);
  if (user?.farm?.zipCode) setLocalStorageZipCode(user.farm.zipCode);

  const crumbs = user ? [{ name: user.farm?.name || t("modules:navigation.overview.farm"), link: "/farm" }, { name: t("cropExplorer") }] : [];

  return (
    <CropExplorationContextProvider>
      <MainPage fullWidth pageName="crop-explorer-page" share={{ title: t("cropExplorer") }} showMobileAlert>
        <Flex className="crop-explorer container" data-testid="crop-explorer-container" justify="space-between">
          <Flex className="crop-explorer main" data-testid="crop-explorer-main" vertical={true}>
            <Header className="crop-explorer header" dataTestId="crop-explorer-header" crumbs={crumbs} title={t("cropExplorer")} />
            <CropExplorerTabs />
          </Flex>
          <Flex className="crop-explorer sidebar" data-testid="crop-explorer-sidebar">
            <CropExplorationSidebar />
          </Flex>
        </Flex>
      </MainPage>
    </CropExplorationContextProvider>
  );
};
